import React, { useState, useRef } from "react";

import {
    Box, 
    TextField,
    FormControlLabel,
    Grid,
    styled,
    Switch
} from '@mui/material';

import {
  LoadingButton
} from '@mui/lab';

// import { useNavigate, useParams } from "react-router-dom";
import { useFormik } from 'formik';
// import CommonSectionHeader from "../common/CommonSectionHeader";

import { useLocations, locationTypes, targetTypes } from "../../../hooks/api/useLocations";
import { useAppContextFeatures } from "../../../context/AppContext";
import { useSystemPrompt } from "../../../hooks/useSystemPrompt";
import { initialValues, validationSchema } from "../../../schema/locations/slotSchema";
// import { useSystemRoutes, routeTypes } from '../../../hooks/useSystemRoutes';
// import { CommonIcons, icons } from "../common/CommonIcons";
import { useTranslations } from "../../../hooks/useTranslations";

const StyledCard = styled(Box)(({ theme }) => ({
    padding: theme.spacing(2)
}));

export default function NewSlot({ parentId, handleOnSuccess }) {

    const { t } = useTranslations({ ns: ["common", "@location"] })
    // const { parentId } = parentId

    // const { parent } = useParams();
    const { promptMessage } = useSystemPrompt();
    const { isLoading, create } = useLocations({ locationType: locationTypes.slot, targetType: targetTypes.slot });
    const { setSystemLoading } = useAppContextFeatures();

    // const navigate = useNavigate();
    // const { getRoute } = useSystemRoutes(routeTypes.admin);
    // const [ savedValues, setSavedValues ] = useState()

    const onSubmit = async (currentValues) => {

        setSystemLoading(true)

        try{
         
            let data = {
                slot: {
                    rack_id: parentId,
                    slot_name: currentValues?.slotName,
                    sequence: currentValues?.sequence,
                    is_default : currentValues?.defaultStatus? 1 : 0,
                    status: currentValues?.status? 1 : 0,
                }
            }

            const response = await create({ data });

            promptMessage(true, `${response?.message}`)

            if(handleOnSuccess) handleOnSuccess()
                
        }catch(error){
            promptMessage(false, `Action Failed (${error?.message})`)
        }   

        setSystemLoading(false)

    }

    const formik = useFormik({
        initialValues,
        validationSchema,
        enableReinitialize: true,
        onSubmit
    });

    const { touched, values, errors, handleChange, setFieldValue } = formik;

    const RenderForm = () => {
        
        return(
            
            <form onSubmit={formik.handleSubmit}>
                <StyledCard>
                    <Grid container spacing={0.5}>

                        <Grid item xs={12} sm={12} md={12}>
                            <Grid container spacing={0.5}>
                                <Grid item xs={6} sm={6} md={4}> 
                                    <FormControlLabel 
                                        sx={{
                                            marginLeft:'1px'
                                        }}
                                        control={
                                            <Switch 
                                                name="status" 
                                                checked={Boolean(values.status)}
                                                onChange={(event, checked) => {
                                                    setFieldValue("status", checked);
                                                }}
                                            />
                                        }     
                                        label={
                                            Boolean(values.status)? t("enabled") : t("disabled")
                                        }
                                    />
                                </Grid>
                                {/* <Grid item xs={6} sm={6} md={4}> 
                                    <FormControlLabel 
                                        sx={{
                                            marginLeft:'1px'
                                        }}
                                        control={
                                            <Switch 
                                                name="defaultStatus" 
                                                checked={Boolean(values.defaultStatus)}
                                                onChange={(event, checked) => {
                                                    setFieldValue("defaultStatus", checked);
                                                }}
                                            />
                                        }     
                                        label={
                                            Boolean(values.defaultStatus)? "Default" : "Not Default"
                                        }
                                    />
                                </Grid> */}
                            
                                <Grid item xs={12} sm={12} md={10}>
                                    <TextField
                                        margin="normal"
                                        size="small"
                                        autoFocus
                                        fullWidth
                                        name={"slotName"}
                                        label={t("slotName")}
                                        type="text"                                         
                                        variant="outlined"
                                        value={values.slotName}
                                        onChange={handleChange}
                                        error={touched.slotName && Boolean(errors.slotName)}
                                        helperText={touched.slotName && errors.slotName}
                                    />
                                </Grid>

                                <Grid item xs={6} sm={6} md={2}>
                                    <TextField
                                        margin="normal"
                                        size="small"
                                        fullWidth
                                        name={"sequence"}
                                        label={t("sequence")}
                                        type="text"                                         
                                        variant="outlined"
                                        value={values.sequence}
                                        onChange={handleChange}
                                        error={touched.sequence && Boolean(errors.sequence)}
                                        helperText={touched.sequence && errors.sequence}
                                    />
                                </Grid>
                            
                            </Grid>
                        </Grid>

                    </Grid>
                </StyledCard>
                <Box 
                    sx={{ 
                        mx: 2,
                        mr: 2
                    }}
                >
                    <LoadingButton
                        type="submit"
                        fullWidth
                        variant="contained"
                        loading={isLoading}
                    >
                        {t('saveChanges')}
                    </LoadingButton>
                </Box>
            </form>
                
        )
    }

    return (
        <Box>

            { RenderForm() }

        </Box>
    )
}